var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "staffs-license-assign" },
    [
      _c("licences", {
        attrs: {
          licenses: _vm.licenses,
          versionedLicenses: _vm.versionedLicenses
        }
      }),
      _vm._v(" "),
      _c("h3", { staticClass: "mt-4" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Attribution des licences")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("p", {
        staticClass: "m-0 fs-3 lh-big",
        domProps: {
          innerHTML: _vm._s(
            _vm.$t.__(
              "sellsyaccountmanager.SubscriptionManager.Staffs.licence_count_on_account",
              _vm.total
            )
          )
        }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "grey m-0 fs-3 lh-big" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Attribuez les en fonction des besoins de vos collaborateurs afin qu’ils puissent utiliser les différents modules proposés dans Sellsy."
              )
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "flex-row br staff-form-container fs-3 p-2 mt-3 gray-0-bkg"
        },
        [
          _c("span", { staticClass: "semibold mr-3" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$l10n.__(
                    "%s collaborateurs au total",
                    _vm.pagination.total
                  )
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__(
                "sellsyaccountmanager.SubscriptionManager.Staffs.add_staff"
              ),
              type: "primary"
            },
            on: { click: _vm.openPopup }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.isTableLoading
        ? _c("TableLoading")
        : _c(
            "CompassTable",
            {
              staticClass: "staffs-license-assign__table",
              attrs: { size: "large", maxHeight: "60%" }
            },
            [
              _c(
                "CompassTableHead",
                { attrs: { isFixed: true } },
                [
                  _c("CompassTableHeadCell", [
                    _vm._v(_vm._s(_vm.$t.__("common.labels.name")) + " ")
                  ]),
                  _vm._v(" "),
                  _c("CompassTableHeadCell", [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t.__(
                            "sellsyaccountmanager.SubscriptionManager.Staffs.job_title"
                          )
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("CompassTableHeadCell", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t.__("common.labels.licence_type")) +
                        "\n            "
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CompassTableBody",
                _vm._l(_vm.staffs, function(staff) {
                  return _c(
                    "CompassTableRow",
                    { key: staff.id },
                    [
                      _c(
                        "CompassTableBodyCell",
                        [
                          _c(
                            "CompassAvatar",
                            _vm._b(
                              { attrs: { size: "small" } },
                              "CompassAvatar",
                              _vm.formatUserToCompassAvatar(staff),
                              false
                            )
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-2 semibold" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(staff.firstname + " " + staff.lastname) +
                                "\n                    "
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("CompassTableBodyCell", [
                        _c("span", { staticClass: "darkgrey" }, [
                          _vm._v(_vm._s(staff.position))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "CompassTableBodyCell",
                        { attrs: { maxWidth: "232px", minWidth: "232px" } },
                        [
                          _vm.availableLicenses.length
                            ? [
                                staff.loading
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "select-loader compass-input compass-input--disabled compass-input--medium"
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "select-loader__loader"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "select-loader__message"
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.$t.__(
                                                    "common.labels.allocation_in_progress"
                                                  )
                                                ) +
                                                "\n                            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("CompassIcon", {
                                          attrs: { icon: "caret-down" }
                                        })
                                      ],
                                      1
                                    )
                                  : _c(
                                      "CompassSelect",
                                      {
                                        staticClass:
                                          "staffs-license-assign__select-license",
                                        attrs: { value: staff.license },
                                        on: {
                                          "update:value": function($event) {
                                            return _vm.updateLicense(
                                              $event,
                                              staff
                                            )
                                          }
                                        }
                                      },
                                      _vm._l(_vm.availableLicenses, function(
                                        license
                                      ) {
                                        return _c(
                                          "CompassDropdownSelectOption",
                                          {
                                            key: license.value,
                                            attrs: {
                                              disabled: license.disabled,
                                              label: license.label,
                                              value: license.value
                                            }
                                          }
                                        )
                                      }),
                                      1
                                    )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          ),
      _vm._v(" "),
      _vm.pagination.total > 0
        ? _c("TablePagination", {
            staticClass: "listing-wrapper__pagination",
            attrs: { pagination: _vm.pagination, isLoading: false },
            on: { "update-pagination": _vm.fetchStaffs }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }